import { render, staticRenderFns } from "./AiBetaChip.vue?vue&type=template&id=3fd06766&scoped=true"
import script from "./AiBetaChip.vue?vue&type=script&lang=js"
export * from "./AiBetaChip.vue?vue&type=script&lang=js"
import style0 from "./AiBetaChip.vue?vue&type=style&index=0&id=3fd06766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd06766",
  null
  
)

export default component.exports